interface JwtPayload {
  username: string;
  displayName: string;
  email: string;
  roles: string;
  employeeId: string;
  sub: string;
  iss: string;
  aud: string[];
  iat: number;
  exp: number;
}

class JwtService {
  public static DecodeToken = (token: string): JwtPayload | null => {
    try {
      // JWT tokens have 3 parts separated by dots: header.payload.signature
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }

      // Decode the payload (second part)
      const payload = parts[1];

      // Add padding if needed for base64 decoding
      const paddedPayload =
        payload + '='.repeat((4 - (payload.length % 4)) % 4);

      // Decode base64 and parse JSON
      const decodedPayload = JSON.parse(atob(paddedPayload));

      return decodedPayload as JwtPayload;
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  };

  public static IsTokenExpired = (token: string): boolean => {
    try {
      const payload = JwtService.DecodeToken(token);
      if (!payload || !payload.exp) {
        return true;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  };

  public static GetUserFromToken = (
    token: string
  ): {
    givenName: string;
    displayName: string;
    email: string;
    username: string;
    roles: string;
    employeeId: string;
  } | null => {
    try {
      const payload = JwtService.DecodeToken(token);
      if (!payload) {
        return null;
      }

      // Extract the first name from displayName
      let givenName = 'User';
      if (payload.displayName) {
        const nameParts = payload.displayName.split(',');
        if (nameParts.length > 1) {
          givenName = nameParts[1].trim();
        } else {
          givenName = payload.displayName.trim();
        }
      }

      return {
        givenName,
        displayName: payload.displayName,
        email: payload.email,
        username: payload.username,
        roles: payload.roles,
        employeeId: payload.employeeId,
      };
    } catch (error) {
      console.error('Error extracting user from token:', error);
      return null;
    }
  };
}

export { JwtService, type JwtPayload };
